export function isNotNullOrUndefined<T>(
  parameter: T | undefined | null
): parameter is T {
  return parameter !== undefined && parameter !== null;
}
